import { Activity, BarChart3, LayoutDashboard, Link as LinkIcon, MessageSquare, Network, Receipt, UserPlus, Users } from "lucide-react";

export const managerNav = [
  { label: "Dashboard", to: "/manager/dashboard", icon: LayoutDashboard },
  { label: "My Clients", to: "/manager/clients", icon: Users },
  { label: "My Team", to: "/manager/team", icon: Network },
  { label: "Activity Feed", to: "/manager/activity", icon: Activity },
  { label: "Reports", to: "/manager/reports", icon: BarChart3 },
  { label: "IB Commission", to: "/manager/ib-commission", icon: Receipt },
  { label: "Support", to: "/manager/support", icon: MessageSquare },
  { label: "Referral Links", to: "/manager/referral", icon: LinkIcon },
  { label: "Profile", to: "/manager/profile", icon: UserPlus },
];
